import Individual from '@/modules/individual/models/Individual'

export default {
  namespaced: true,
  actions: {
    async register({ dispatch }, { payload }) {
      try {
        const individual = await this._vm.$axios.post(
          '/api/individuals/signup',
          payload
        )
        dispatch(
          'entities/individuals/insert',
          { data: individual },
          { root: true }
        )
        return individual
      } catch (error) {
        throw error
      }
    },
    async login({ _dispatch }, { payload }) {
      try {
        const accessToken = await this._vm.$axios.post(
          '/api/individuals/oauth/token',
          {
            username: payload.username,
            password: payload.password
          }
        )
        return accessToken
      } catch (error) {
        throw error
      }
    },
    async forgotPassword({ _dispatch }, { payload }) {
      try {
        await this._vm.$axios.post('/api/individuals/forgot-password', payload)

        return true
      } catch (error) {
        throw error
      }
    },
    async resetPassword({ _dispatch }, { payload }) {
      try {
        await this._vm.$axios.post('/api/individuals/reset-password', payload)

        return true
      } catch (error) {
        throw error
      }
    },
    async startLesson({ _dispatch }, { payload }) {
      try {
        const individualLesson = await this._vm.$axios.post(
          `/api/individuals/lessons/${payload.slug}`
        )
        return individualLesson
      } catch (error) {
        throw error
      }
    },
    async fetchUserLessons({ _dispatch }) {
      const individualLessons = await this._vm.$axios.get(
        '/api/individuals/user-lessons'
      )

      return individualLessons
    },
    async resetUsername({ _dispatch }, { payload }) {
      try {
        const individual = await this._vm.$axios.post(
          '/api/individuals/forgot-username',
          payload
        )

        return individual
      } catch (error) {
        throw error
      }
    },
    async getSiblings({ _dispatch }) {
      try {
        const siblings = await this._vm.$axios.get('/api/individuals/siblings')
        Individual.deleteAll()
        Individual.insertOrUpdate({ data: siblings }, { root: true })
        return siblings
      } catch (error) {
        throw error
      }
    },
    async switchToSibling({ _dispatch }, childId) {
      try {
        const accessToken = await this._vm.$axios.post(
          `/api/individuals/siblings/${childId}/accounts`
        )
        return accessToken
      } catch (error) {
        throw error
      }
    },
    async switchToParent({ _dispatch }) {
      try {
        const accessToken = await this._vm.$axios.post(
          '/api/individuals/parent-accounts'
        )
        return accessToken
      } catch (error) {
        throw error
      }
    },
    async fetchChildForParent({ _dispatch }, childId) {
      const child = await this._vm.$axios.get(
        `/api/parents/children/${childId}`
      )

      Individual.insert({ data: child }, { root: true })

      return child
    }
  }
}
